import React, { useEffect, useState } from 'react';
import { getNews } from '../news-api';
import NewsCard from './NewsCard.js';
import './card.css';
import Iframe from 'react-iframe'

function NewsContainer() {
  const [news, setNews] = useState([]);


//fetched news - while filtering out articles with the same title titles
  useEffect(() => {
    getNews().then(data => {
    data = data.filter((article, index, self) =>
    index === self.findIndex((t) => t.title === article.title))
    setNews(data)
   });
  }, []);
  //useEffect function, getNews then resolve data
  //data assigned to data.filter fucntion
  //array.filter(function(currentValue, index, arr), thisValue) - current val req, index/arr optional
  //array.findIndex(function(currentValue, index, arr), thisValue) - current val req, index/arr optional
  //title strict equal to title then setNews with data


  //orignal useEffect(), before adding the filter to remove articles with the same titles
  // useEffect(() => {
  //   getNews().then(data => setNews(data));
  // }, []);

  return(
  <div>
  <div className="chart-data">
    <div className="chart" style = {{ height:"400px", background:"#1D2330", overflow:"hidden", boxSizing:"border-box", border:"1px solid #282E3B", borderRadius:"4px", textAlign:"right", lineHeight:"14px", fontSize:"12px", fontFeatureSettings:"normal", textSizeAdjust:"100%", boxShadow:"inset 0 -20px 0 0 #262B38", padding:"0px", margin:"0px", width:"100%" }}><div style={{height:"413px", padding:"0px", margin:"0px", width:"100%" }}>
    <Iframe url="https://widget.coinlib.io/widget?type=full_v2&theme=dark&cnt=6&pref_coin_id=1505&graph=yes" width="100%" height="409px" scrolling="auto" marginWidth="0" marginHeight="0" frameBorder="0" border="0" style={{ border:"0", margin:"0", padding:"0" }}></Iframe></div><div style= {{color:"#626B7F", lineHeight:"14px", fontWeight: 400, fontSize:"11px", boxSizing:"border-box", padding:"2px 6px", width:"100%",
    fontFamily:"Verdana, Tahoma, Arial, sans-serif" }}><a href="https://coinlib.io/widgets"style= {{ fontWeight: 500, color:"#626B7F", textDecoration:"none", fontSize:"11px"}}>coin</a></div></div>

    <div className="chart" style={{ height:"400px", background:"#1D2330", overflow:"hidden", boxSizing:"border-box", border:"1px solid #282E3B", borderRadius:"4px", textAlign:"right", lineHeight:"14px", fontSize:"12px", fontFeatureSettings:"normal", textSizeAdjust:"100%", boxShadow:"inset 0 -20px 0 0 #262B38", padding:"1px", width:"100%" }}><div style={{height:"540px", padding:"0px", margin:"0px", width:"100%"}}>
    <Iframe url="https://widget.coinlib.io/widget?type=chart&theme=dark&coin_id=859&pref_coin_id=1505" width="100%" height="536px" scrolling="auto" marginWidth="0" marginHeight="0" frameBorder="0" border="0" style={{ border:"0",  margin:"0", padding:"0", lineHeight:"14px"}}> </Iframe></div><div style={{ color:"#626B7F", lineHeight:"14px", fontWeight: 400, fontSize:"11px", boxSizing:"border-box", padding:"2px 6px", width:"100%",
    fontFamily:"Verdana, Tahoma, Arial, sans-serif" }}><a href="https://coinlib.io/widgets"style={{fontWeight: 500, color:"#626B7F", textDecoration:"none", fontSize:"11px"}}>Bitcoin</a></div></div>
   </div>

    <div style= {{ height:100, backroundColor:"#1D2330", overflow:"hidden", boxSizing:"border-box",
    textAlign: "right", lineHeight:"14px", blockSize:"70px", fontSize: "28px", fontFeatureSettings:"normal",
    textSizeAdjust:"100%", width:"100%" }}>
    <div style= {{ height:"50px", width:"100%" }} ><Iframe url="https://widget.coinlib.io/widget?type=horizontal_v2&theme=dark&pref_coin_id=1505&invert_hover=no"
    width="100%" height="50px" scrolling="auto" marginWidth="0" marginHeight="0" frameBorder="0" border="0" style= {{ border:'0', margin:'0', padding:'0' }}></Iframe></div><div style=
    {{ color: "#626B7F", lineHeight:"18px", fontWeight:900, fontSize:"16px", boxSizing:"border-box", padding:"6px 6px", width:"100%", fontFamily:"Verdana, Tahoma, Arial, sans-serif"}}>
    <a href="https://coinlib.io/widgets" style= {{ fontWeight:"500", color:"#626B7F", textDecoration:"none", fontSize:"18px" }}></a></div></div>

    <div className="cardWrapper">
       {news.map((item, index) => <NewsCard key={index} props={item} />)}
    </div>
  </div>)
}

export default NewsContainer

//Notes:
//cardWrapper class is the parent flex container to the cards class in the NewsCard component.
//In order for flexbox to work, you need to assign flex parent to a parent component of the child flex items,
//flex will not work if the parent and child are in the same component,
//it will cause api to populate in a brand new flex parent for each item,
//instead of rendering one flex parent and cards for each api item.
